import { Fetch } from '../../shared/types';

export const logout = (fetch: Fetch): Promise<void> => fetch(`/logout`);

export default logout;
